/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Hero_EyebrowInputs */

const es_cap_hero_eyebrow = /** @type {(inputs: Cap_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para patrones y capitanes`)
};

const gl_cap_hero_eyebrow = /** @type {(inputs: Cap_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para patróns e capitáns`)
};

const en_cap_hero_eyebrow = /** @type {(inputs: Cap_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For skippers and captains`)
};

/**
* | output |
* | --- |
* | "For skippers and captains" |
*
* @param {Cap_Hero_EyebrowInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_hero_eyebrow = /** @type {((inputs?: Cap_Hero_EyebrowInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Hero_EyebrowInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_hero_eyebrow(inputs)
	if (locale === "en") return en_cap_hero_eyebrow(inputs)
	return es_cap_hero_eyebrow(inputs)
});